import { Pipe, PipeTransform } from '@angular/core';
import {
  mapAiChatEventDetail,
  type EventDetailForChat,
} from './ai-chat-utils';

export type { EventDetailForChat };

/** Pure pipe so mapping only re-runs when `output` reference changes. */
@Pipe({
  name: 'aiChatEventDetail',
  pure: true,
})
export class AiChatEventDetailPipe implements PipeTransform {
  transform(output: unknown): EventDetailForChat | null {
    return mapAiChatEventDetail(output);
  }
}
